import { trustStats } from '../../../mocks/homeData';

export default function TrustBar() {
  return (
    <section className="bg-[#0E0E0E] border-y border-white/10 py-0">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
          {trustStats.map((stat, i) => (
            <div key={i}
              className="relative flex flex-col items-center justify-center py-8 px-6 text-center group hover:bg-[#FF6B35]/8 transition-all duration-300 cursor-default"
              style={{ borderRight: i < trustStats.length - 1 ? '1px solid rgba(255,255,255,0.07)' : 'none' }}>
              <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#FF6B35] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              <div className="w-9 h-9 flex items-center justify-center bg-[#FF6B35]/15 rounded-lg mb-3 group-hover:bg-[#FF6B35]/25 transition-colors">
                <i className={`${stat.icon} text-[#FF6B35] text-lg`} />
              </div>
              <span className="font-display font-black text-2xl lg:text-3xl text-white leading-none mb-1.5">{stat.number}</span>
              <span className="text-gray-500 text-xs uppercase tracking-widest font-semibold">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
